import { createContext } from 'react';

export default createContext({ recaptchaRef: { current: null } });
